import { createAction, props } from "@ngrx/store";

import {
  CreateProductRequest,
  EditProductRequest,
  Product,
} from "./product.model";

export const switchProduct = createAction(
  "[Product] Switch Product",
  props<{ id: string | null }>()
);

export const loadAvailableProductsDetails = createAction(
  "[Product] Load Available Products Details"
);

export const getAvailableProductDetailsSuccess = createAction(
  "[Request] Get Available Products Details Success",
  props<{ products: Product[] | null }>()
);

export const editProduct = createAction(
  "[Product] Edit Product",
  props<{ product: EditProductRequest }>()
);

export const createProduct = createAction(
  "[Product] Create Product",
  props<{ product: CreateProductRequest }>()
);

export const editProductSuccess = createAction(
  "[Product] Edit Product Success",
  props<{ product: Product }>()
);

export const createProductSuccess = createAction(
  "[Product] Create Product Success",
  props<{ product: Product }>()
);

export const productActionFailure = createAction(
  "[Product] Product Action Failure",
  props<{ error: string }>()
);
